import React from 'react';
import { Link, matchPath, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

function MainSidebarItem(props) {
  const {
    to, children, location, exact, disabled,
  } = props;

  const isActive = !disabled && !!matchPath(location.pathname, {
    path: to,
    exact,
    strict: true,
  });

  const liClassName = [
    isActive ? 'active' : '',
    disabled ? 'disabled-nav-item' : '',
  ].filter(Boolean).join(' ');

  /* istanbul ignore next */
  if (disabled) {
    return (
      <li className={liClassName}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          aria-disabled
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <span>{children}</span>
        </a>
      </li>
    );
  }

  /* istanbul ignore next */
  return (
    <li className={liClassName}>
      <Link to={to}>
        <span>{children}</span>
      </Link>
    </li>
  );
}

MainSidebarItem.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  disabled: PropTypes.bool,
};

MainSidebarItem.defaultProps = {
  exact: false,
  disabled: false,
};

export { MainSidebarItem };

export default withRouter(MainSidebarItem);
